import { Pipe, PipeTransform } from "@angular/core";
import { BlockCollectionTypes } from "../../app/api/common/model-enums/block-collection-types.enum";
import { ItemsAdLayoutBlockBlocksRefs } from "../../app/api/packbo/models/items-ad-layout-block-blocks-refs";
import { ItemsPagesBlocksRefs } from "../../app/api/packbo/models/items-pages-blocks-refs";

type BlockRefs = ItemsPagesBlocksRefs | ItemsAdLayoutBlockBlocksRefs;

@Pipe({
    name: "filterBlocks"
})
export class FilterBlocksPipe implements PipeTransform {
    public transform(blocks: BlockRefs[], collectionType: "content" | "ads"): BlockRefs[] {
        if (!blocks || !Array.isArray(blocks)) {
            return [];
        }

        const isAdBlock = collectionType === "ads";
        return blocks.filter((block) =>
            isAdBlock
                ? block.collection === BlockCollectionTypes.AD_BLOCK
                : block.collection !== BlockCollectionTypes.AD_BLOCK
        );
    }
}
